import { FormControl, FormErrorMessage, InputGroup, NumberInput, NumberInputField } from '@chakra-ui/react';
import React from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { useCheckoutCashflowViewModel } from '../../../models/CheckoutCashflowViewModel';

type AmountFieldProps = {
  form: UseFormReturn<{ amount: number }, any>;
};

export const AmountField: React.FC<AmountFieldProps> = ({ form }) => {
  const viewModel = useCheckoutCashflowViewModel();
  const suggestedAmounts = viewModel.getSuggestedAmounts();

  return (
    <FormControl isInvalid={Boolean(form.formState.errors.amount)}>
      <Controller
        control={form.control}
        name="amount"
        rules={{
          max: {
            message: `Your maximum investment amount is $${suggestedAmounts.maxAmount}`,
            value: suggestedAmounts.maxAmount,
          },
          min: {
            message: `A minimum investment amount of $${suggestedAmounts.minAmount} is required`,
            value: suggestedAmounts.minAmount,
          },
          required: 'Please enter an amount',
        }}
        render={({ field }) => (
          <NumberInput
            value={field.value}
            format={(value) => (value ? `$${value}` : '')}
            onChange={(val, num) => {
              field.onChange(val);
              if (isNaN(num)) num = 0;
              viewModel.setAmount(num);
            }}
            inputMode="numeric"
            isValidCharacter={(character) => !isNaN(Number(character))}>
            <InputGroup>
              <NumberInputField
                id="amount"
                placeholder={`$${suggestedAmounts.suggestedAmount ?? 0}`}
                autoFocus={true}
                height="80px"
                borderStyle={'solid'}
                borderWidth="2px"
                borderColor="blue.500"
                fontSize={'24px'}
                maxLength={12}
              />
            </InputGroup>
          </NumberInput>
        )}
      />

      <FormErrorMessage>{form.formState.errors.amount?.message}</FormErrorMessage>
    </FormControl>
  );
};
